
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import _ from 'lodash';
    import * as Publicaciones from '@/__env/lib/MercadoLibre/Publicaciones';
    import * as Articulos from '@/__env/lib/Articulos';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Publicacion } from '@/__env/lib/MercadoLibre/Publicaciones';
    import { Cuenta } from '@/__env/lib/MercadoLibre/Cuentas/Cuentas';
    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }

        public get TiposArticulo()
        {
            return [
                Articulos.Tipos.Nacional,
                Articulos.Tipos.Importado,
                Articulos.Tipos.ImportadoSinReposicion,
                Articulos.Tipos.ImportadoTerceros,
            ];
        };

        public get Tipos()
        {
            return [
                Publicaciones.Tipos.Normal,
                Publicaciones.Tipos.Financiada,
            ];
        };

        public get Estados()
        {
            return [
                Publicaciones.Estados.Activa,
                Publicaciones.Estados.Pausada,
            ];
        };

        public get Cuentas()
        {
            return [
                Cuenta.CASAJARSE,
                Cuenta.JARSEINDUSTRIALCOMERCIALSA,
                Cuenta.DRLINEABLANCA_INDUSTRIAL,
            ];
        };

        public Estado: string[] = [Publicaciones.Estados.Activa.Id];
        @Watch( 'Estado', { immediate: true } )
        onEstado()
        {
            this.Buscador.Parametros.estado = this.Estado.join( ',' );
            if ( this.Buscador.Estado == 'ok' || this.Buscador.Estado == 'vacio' )
            {
                this.Buscador.Buscar( 1 );
            }
        }

        public TipoArticulo: string[] = this.TiposArticulo.map( x => x.Id );
        @Watch( 'TipoArticulo', { immediate: true } )
        onTipoArticulo()
        {
            this.Buscador.Parametros.tipo_articulo = this.TipoArticulo.join( ',' );
            if ( this.Buscador.Estado == 'ok' || this.Buscador.Estado == 'vacio' )
            {
                this.Buscador.Buscar( 1 );
            }
        }

        public Tipo: string[] = this.Tipos.map( x => x.Id );
        @Watch( 'Tipo', { immediate: true } )
        onTipo()
        {
            this.Buscador.Parametros.tipo = this.Tipo.join( ',' );
            if ( this.Buscador.Estado == 'ok' || this.Buscador.Estado == 'vacio' )
            {
                this.Buscador.Buscar( 1 );
            }
        }

        public Cuenta: string[] = this.Cuentas.map( x => x.Nickname );
        @Watch( 'Cuenta', { immediate: true } )
        onCuenta()
        {
            this.Buscador.Parametros.cuenta = this.Cuenta.join( ',' );
            if ( this.Buscador.Estado == 'ok' || this.Buscador.Estado == 'vacio' )
            {
                this.Buscador.Buscar( 1 );
            }
        }

        mounted()
        {
            this.Buscador.Buscar( 1 );
        }

        public Abierto: boolean = false;
        public Cargando: boolean = false;
        public get Ok(): boolean
        {
            return ( this.Estado && this.Estado.esActiva && this.Seleccionados.filter( x => x.Estado.esPausada ).hasRows() ) ||
                ( this.Estado && this.Estado.esPausada && this.Seleccionados.filter( x => x.Estado.esActiva ).hasRows() );
        }

        public async Ejecutar()
        {
            if ( await Utiles.Mensajes.SiNo( 'Editar estado', `¿Sobreescribir el estado de  ${this.Seleccionados.length} publicaciones?` ) )
            {
                this.Cargando = true;
                if ( this.Transporte && this.Transporte.Existe )
                {
                    for ( let e of this.Seleccionados )
                    {
                        if ( !e.Envio.Tipo.esRetiraCliente )
                        {
                            e.Envio.EmpresaLogistica = this.Transporte;
                            await e.Envio.save();
                        }
                    }
                    this.Controlador.Buscador.Buscar();
                    this.Controlador.RecargarEstadistica();
                }
                this.Cargando = false;
                this.Cerrar();
            }


        }

        public async Cerrar()
        {
            this.$emit( 'cerrar' );
            this.Abierto = false;

        }
    }
